const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_753",
  "data-name": "Rectangle 753",
  width: 12,
  height: 28,
  transform: "translate(0 -0.333)",
  fill: "#008941"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2715",
  "data-name": "Group 2715",
  transform: "translate(-607.251 80.473)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2714",
  "data-name": "Group 2714",
  transform: "translate(607.251 -80.141)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2713",
  "data-name": "Group 2713",
  transform: "translate(0 0)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2421",
  "data-name": "Path 2421",
  d: "M5.909,78.066,4.688,79.287l5.181,5.181a.863.863,0,0,0,1.221,0l5.181-5.181-1.221-1.221-3.707,3.707V66.944l3.707,3.707,1.221-1.221L11.09,64.249a.863.863,0,0,0-1.221,0L4.688,69.431l1.221,1.221,3.707-3.707V81.773Z",
  transform: "translate(-4.495 -60.508)",
  fill: "#008941"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_751",
  "data-name": "Rectangle 751",
  width: 12,
  height: 2,
  transform: "translate(0 -0.333)",
  fill: "#008941"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_752",
  "data-name": "Rectangle 752",
  width: 12,
  height: 2,
  transform: "translate(0 25.667)",
  fill: "#008941"
}))));
function SvgIconfeatherSort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 28,
    viewBox: "0 0 12 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconfeatherSort);
export default __webpack_public_path__ + "static/media/Icon feather-sort.cd9e7ef9.svg";
export { ForwardRef as ReactComponent };